<template>
  <div class="tc-signup-page">
    <div class="container h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-md-6 col-lg-5">
          <div class="tc-signup-glass-card p-5">
            <div class="text-center mb-4">
              <h2 class="fw-bold tc-signup-text-gradient mb-2">Create Account</h2>
              <p class="text-muted">Join the platform today</p>
            </div>
            <Signup />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Signup from '@lib/frontend/components/Signup.vue'
export default {
  components: { Signup }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');

.tc-signup-page {
  font-family: 'Outfit', sans-serif;
  min-height: 100vh;
  background-color: #F8F9FC;
  background-image: radial-gradient(circle at 10% 20%, rgba(108, 93, 211, 0.05) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(108, 93, 211, 0.05) 0%, transparent 20%);
}

.tc-signup-glass-card {
  background: #ffffff;
  border: 1px solid #E2E2EA;
  border-radius: 24px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05);
}

.tc-signup-text-gradient {
  background: linear-gradient(135deg, #6C5DD3, #8a7df0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>